import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import React, { createContext } from "react";
import { log } from "@jutro/logger";
var createNoProviderWarning = function (methodName) {
  return function () {
    var message = 'You should not use "'.concat(methodName, '()" outside a <ModalNextProvider>');
    return log.error(message), _Promise.reject(new Error(message));
  };
};
export var ModalNextContext = createContext({
  showAlert: createNoProviderWarning("showAlert"),
  showConfirm: createNoProviderWarning("showConfirm"),
  showModal: createNoProviderWarning("showModal"),
  portalClassName: void 0
});